import axios from 'axios'

// const baseUrl = 'http://192.168.14.167:5001/api/'
const baseUrl = 'https://data.ccmb.res.in/gear/backend/api/'


const genomeDBURL = `${baseUrl}genomes/`
const mutationsDBURL = `${baseUrl}mutations/`
const mutationDataDBURL = `${baseUrl}mutation_data/`
const plotsDBURL = `${baseUrl}plots/`
const statsDBURL = `${baseUrl}stats/`
const sharedVariantDataDBURL = `${baseUrl}shared_variants/`
const stateDataDBURL = `${baseUrl}state_data/`
const situationDataDBURL = `${baseUrl}situation/`

class PostService {

	// Get Genome Posts
	static getGenomePosts(options, sort=0, initial=false) {
		let url = genomeDBURL + '?';
		if (options !== undefined) {
      const keys = Object.keys(options)
      keys.forEach(k => {
        switch(k) {
          case "age":
            url = `${url}age=${options.age[0]}-${options.age[1]}&`
            break
          
          case "division":
            url = `${url}division=${options.division.join(',')}&`
            break
            
          case "gender":
            url = `${url}gender=${options.gender.join(',')}&`
            break
            
          case "clade":
            url = `${url}clade=${options.clade.join(',')}&`
            break
          
          case "nextstrain_clade":
            url = `${url}nextstrain_clade=${options.nextstrain_clade.join(',')}&`
            break
          
          case "gisaid_clade":
            url = `${url}gisaid_clade=${options.gisaid_clade.join(',')}&`
            break
          
          case "pangolin_lineage":
            url = `${url}pangolin_lineage=${options.pangolin_lineage.join(',')}&`
            break
          
          case "date":
            url = `${url}date=${options.date[0]}_${options.date[1]}`
            break
          
          case "n_percent":
            url = `${url}n_percent=${options.n_percent}&`
            break
          
          case "gap_percent":
            url = `${url}gap_percent=${options.gap_percent}&`
            break
          
          case "page":
            url = `${url}page=${options.page}&`
            break

          case "pageSize":
            url = `${url}pageSize=${options.pageSize}&`
            break

          default:
            break
        }
      })
    }

    if (sort !== 0) {
      url = `${url}sort_key=${sort.key}&sort_order=${sort.order}`
    }

    if (initial) {
      url = `${url}&initial=1`
    }
    
		const promise =  new Promise( (resolve, reject) => {
			return axios.get(url, {
				mode: 'cors' 
			}).then( function(response) {
				resolve(response.data)
			}).catch( function(error){
				reject(error)
			})
    })
    
		return promise
  }

  static getMutationPosts(options, sort=0, initial=false) {
    let url = `${mutationsDBURL}/?type=table`;
    console.log(options)
    if(options !== undefined) {
      const keys = Object.keys(options)
      keys.forEach(k => {
        switch (k) {
          case "position":
            url = `${url}position=${options.position[0]}-${options.position[1]}&`
            break
          
          case "percent":
            url=`${url}percent=${options.percent[0]}-${options.percent[1]}&`
            break

          case "gene":
            for (let l in options.gene) {
              url = `${url}&gene[]=${options.gene[l]}`
            }
            url = `${url}&`
            break
          
          case "page":
            url = `${url}&page=${options.page}&`
            break

          case "pageSize":
            url = `${url}&page_size=${options.pageSize}&`
            break
          
          default:
            break;
        }
      })
    }

    url = `${url}sort_key=${sort.key}&sort_order=${sort.order}`

    if (initial) {
      url = `${url}&initial=1`
    }

    const promise = new Promise( (resolve, reject) => {
      return axios.get(url, {
        mode: 'cors'
      }).then( function(response) {
        resolve(response.data)
      }).catch( function(error) {
        reject(error)
      })
    })

    return promise
  }

  static getMutationData(key) {
    let url = `${mutationDataDBURL}${key}`
    const promise =  new Promise( (resolve, reject) => {
			return axios.get(url, {
				mode: 'cors' 
			}).then( function(response) {
				resolve(response.data)
			}).catch( function(error){
				reject(error)
			})
		})
		return promise
  }

  // static searchVariantPosts(options) {
  //   let url = variantsDBURL;
  //   let key = Object.keys(options)[0]
  //   let value = options[key]
  //   url = `${sharedVariantDataDBURL}/variant_search=${key}_${value}`
  //   const promise = new Promise( (resolve, reject) => {
  //     return axios.get(url, {
  //       mode: 'cors'
  //     }).then( function(response) {
  //       resolve(response.data)
  //     }).catch( function(error) {
  //       reject(error)
  //     })
  //   })

  //   return promise
  // }

  // static getSharedVariantPosts(options) {
  //   let url = variantsDBURL;
  //   let selected_variants = options.variant_ids.join(',')
  //   url = `${sharedVariantDataDBURL}/selected=${selected_variants}`
  //   const promise = new Promise( (resolve, reject) => {
  //     return axios.get(url, {
  //       mode: 'cors'
  //     }).then( function(response) {
  //       resolve(response.data)
  //     }).catch( function(error) {
  //       reject(error)
  //     })
  //   })

  //   return promise
  // }

  static getPlotData(plotName, options) {
    let url = `${plotsDBURL}?plot=${plotName}`
    if (plotName === 'enrichVariantsFrequency') {
      options.forEach( d => { url = `${url}&variants[]=${d}` } )
    }
    if (plotName === 'variantSpecificData') {
      url = `${url}&variant=${options.variant}`
    }
    if (plotName === 'topPangolinLineages') {
      url = `${url}&startDate=${options.startDate}&endDate=${options.endDate}`
    }
    const promise =  new Promise( (resolve, reject) => {
			return axios.get(url, {
				mode: 'cors' 
			}).then( function(response) {
				resolve(response.data)
			}).catch( function(error){
				reject(error)
			})
		})
		return promise
  }
  
  static getStat(key) {
    let url = `${statsDBURL}?key=${key}`
    const promise =  new Promise( (resolve, reject) => {
			return axios.get(url, {
				mode: 'cors' 
			}).then( function(response) {
				resolve(response.data)
			}).catch( function(error){
				reject(error)
			})
		})
		return promise
  }

  static getStateData(key) {
    let url = `${stateDataDBURL}${key}`
    const promise =  new Promise( (resolve, reject) => {
			return axios.get(url, {
				mode: 'cors' 
			}).then( function(response) {
				resolve(response.data)
			}).catch( function(error){
				reject(error)
			})
		})
		return promise
  }

  static getSituationData(key) {
    let url = `${situationDataDBURL}`
    if (key.plot === 'recentGenomesStateDistribution') {
      url = `${url}?plot=${key.plot}&startDate=${key.startDate}&endDate=${key.endDate}`
    }

    else if (key.plot === 'recentGenomesSampleDemographics') {
      url = `${url}?plot=${key.plot}&startDate=${key.startDate}&endDate=${key.endDate}`
    }

    else if (key.plot === 'recentGenomesVOCStats') {
      url = `${url}?plot=${key.plot}&startDate=${key.startDate}&endDate=${key.endDate}`
      for (let v in key.voc) {
        url = `${url}&voc[]=${key.voc[v]}`
      }
    }

    else if (key.plot === 'vocTimeline') {
      url = `${url}?plot=${key.plot}&cladeType=${key.cladeType}&startDate=${key.startDate}&endDate=${key.endDate}`
    }

    else if (key.plot === 'variantGeomapTimeline') {
      url = `${url}?plot=${key.plot}&variant=${key.variant}&startDate=${key.startDate}&endDate=${key.endDate}`
    }

    else if (key.plot === 'topPangolinLineages') {
      url = `${url}?plot=${key.plot}&startDate=${key.startDate}&endDate=${key.endDate}`
    }

    else if (key.plot === 'topPangolinLineagesCounts') {
      url = `${url}?plot=${key.plot}`
    }

    else if (key.plot === 'situationCladeFrequencyTimeline') {
      url = `${url}?plot=${key.plot}&startDate=${key.startDate}&endDate=${key.endDate}`
      for (let l in key.lineages) {
        url = `${url}&lineages[]=${key.lineages[l]}`
      }
    }

    const promise =  new Promise( (resolve, reject) => {
			return axios.get(url, {
				mode: 'cors' 
			}).then( function(response) {
				resolve(response.data)
			}).catch( function(error){
				reject(error)
			})
		})
		return promise
  }

}

export default PostService;